import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";
import {DjPsychoSymbol} from "../reels/DjPsychoSymbol";
import {DjPsychoSound} from "../sound/DjPsychoSound";

export class DjPsychoXBPMRunner implements ISimplePresentation {
    public shouldRun(): boolean {
        return (DjPsycho.model.xBPMPositions.length > 0);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: TimelineLite = new TimelineLite({
                delay: 0.2,
                onComplete: () => {
                    controller.finish();
                }
            }),
            xBPMPositions: number[][] = DjPsycho.model.xBPMPositions;
        let durationTillNow: number;

        tl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(tl);
            });
        }, 0);

        for (let ctr: number = 0; ctr < xBPMPositions.length; ctr++) {
            durationTillNow = tl.totalDuration();

            tl.add([
                () => {
                    // #153
                    DjPsycho.soundPlayer.playSound(DjPsychoSound.FEATURE_X_BPM);
                },
                DjPsycho.xBPMView.playAttentionAnimation(xBPMPositions[ctr][0], xBPMPositions[ctr][1])
            ]);

            for (let reel: number = 0; reel < DjPsycho.reelsNum; reel++) {
                if (xBPMPositions[ctr][0] !== reel) {
                    tl.add([
                        () => {
                            DjPsycho.reelView.getVisibleSymbolAt(reel, xBPMPositions[ctr][1]).setSymbolCount();
                        },
                        DjPsycho.xBPMView.playChargeAnimation(reel, xBPMPositions[ctr][1])
                    ], (durationTillNow + ((Math.abs(reel - xBPMPositions[ctr][0])) * (4 / 30))));
                }
            }

            let symbol: DjPsychoSymbol = DjPsycho.reelView.getVisibleSymbolAt(xBPMPositions[ctr][0], xBPMPositions[ctr][1]);

            tl.add([
                DjPsycho.xBPMView.playWildAnimation(xBPMPositions[ctr][0], xBPMPositions[ctr][1]),
                () => {
                    symbol.visible = false;

                    // #153
                    DjPsycho.soundPlayer.playSound(DjPsychoSound.FEATURE_TURN_TO_WILD);
                }
            ]);
            tl.add(() => {
                symbol.updateTexture("W");
                symbol.visible = true;
                symbol.setSymbolCount();
            });
        }
    }

    private onSkip(tl: TimelineLite): void {
        tl.totalProgress(1);
    }
}